<template>
  <div class="relative w-full bg-gray-200 h-[1px] rounded-full">
    <div
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white px-3 py-1"
    >
      <span class="text-neutral-500 font-medium">{{ this.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>
